import React from 'react'

/**
 * Spinner — minimal ring loader. Used in centered loading states.
 */
export function Spinner({ size = 22, className = '' }) {
  const cls = ['spinner-dot', className].filter(Boolean).join(' ')
  return <div className={cls} style={{ width: size, height: size }} />
}
